import { customerConstants } from "../_constants/customer.constants";
import { APIcallFunction, headerForPrivateAPI } from "../_helpers";
import { alertActions } from "./alert.actions";

const customerList = (data, isList=true) => {
    try {
        const credential = {
            method: 'POST',
            header: headerForPrivateAPI(),
            body: data || "",
            endPoint: isList ? "/customer/list" : "/customer/assinedCustomer"
        }
        return (dispatch) => {
            dispatch(request({ data }));
            APIcallFunction(credential).then((customer) => {
                dispatch(success(customer));
            },
                (error) => {
                    dispatch(failure(error));
                    // dispatch(alertActions.error(error));
                }
            );
        };
        function request(customer) { return { type: customerConstants.CUSTOMER_GET_LIST_REQUEST, customer }; }
        function success(customer) { return { type: customerConstants.CUSTOMER_GET_LIST_SUCCESS, customer }; }
        function failure(error) { return { type: customerConstants.CUSTOMER_GET_LIST_FAILURE, error }; }

    } catch (error) {
        console.log("Error at customerList", error);
    }
}

const getAlalyticsCount = (data) => {
    try {
        const credential = {
            method: 'POST',
            header: headerForPrivateAPI(),
            body: data || "",
            endPoint: "/customer/getAlalyticsCount"
        }
        return (dispatch) => {
            dispatch(request({ data }));
            APIcallFunction(credential).then((customer) => {
                dispatch(success(customer));
                // dispatch(alertActions.success("success"));
                // dispatch(alertActions.success(user?.message))
            },
                (error) => {
                    dispatch(failure(error));
                    dispatch(alertActions.error(error));
                }
            );
        };
        function request(customer) { return { type: customerConstants.CUSTOMER_ANALYTICS_COUNT_REQUEST, customer }; }
        function success(customer) { return { type: customerConstants.CUSTOMER_ANALYTICS_COUNT_SUCCESS, customer }; }
        function failure(error) { return { type: customerConstants.CUSTOMER_ANALYTICS_COUNT_FAILURE, error }; }

    } catch (error) {
        console.log("Error at getAlalyticsCount", error);
    }
}

const saveCustomer = (data, handleClose, isLive=true) => {
    try {
        const credential = {
            method: 'POST',
            header: headerForPrivateAPI(),
            body: data || "",
            endPoint: "/customer/save"
        }
        return (dispatch) => {
            dispatch(request({ data }));
            APIcallFunction(credential).then((customer) => {
                dispatch(customerList({}, isLive));
                dispatch(success(customer));
                dispatch(alertActions.success("Customer Save Successfully"));
                handleClose();
                // dispatch(alertActions.success(user?.message))
            },
                (error) => {
                    dispatch(failure(error));
                    dispatch(alertActions.error(error));
                }
            );
        };
        function request(customer) { return { type: customerConstants.SAVE_CUSTOMER_REQUEST, customer }; }
        function success(customer) { return { type: customerConstants.SAVE_CUSTOMER_SUCCESS, customer }; }
        function failure(error) { return { type: customerConstants.SAVE_CUSTOMER_FAILURE, error }; }

    } catch (error) {
        console.log("Error at saveCustomer", error);
    }
}

const updateCustomer = (data, handleCloseEditModal, isLive=true) => {
    try {
        const credential = {
            method: 'POST',
            header: headerForPrivateAPI(),
            body: data || "",
            endPoint: "/customer/update"
        }
        return (dispatch) => {
            dispatch(request({ data }));
            APIcallFunction(credential).then((customer) => {
                dispatch(success(customer));
                dispatch(alertActions.success("Customer update successfully"));
                handleCloseEditModal();
                dispatch(customerList({}, isLive));
                // dispatch(alertActions.success(user?.message))
            },
                (error) => {
                    dispatch(failure(error));
                    dispatch(alertActions.error(error));
                }
            );
        };
        function request(customer) { return { type: customerConstants.UPDATE_CUSTOMER_REQUEST, customer }; }
        function success(customer) { return { type: customerConstants.UPDATE_CUSTOMER_SUCCESS, customer }; }
        function failure(error) { return { type: customerConstants.UPDATE_CUSTOMER_FAILURE, error }; }

    } catch (error) {
        console.log("Error at updateCustomer", error);
    }
}

const blockUnblock = (data) => {
    try {
        const credential = {
            method: 'POST',
            header: headerForPrivateAPI(),
            body: data || "",
            endPoint: "/customer/blockUnblock"
        }
        return (dispatch) => {
            dispatch(request({ data }));
            APIcallFunction(credential).then((customer) => {
                dispatch(customerList())
                dispatch(success(customer));
                dispatch(alertActions.success("Customer Status Update Successfully"));
                // dispatch(alertActions.success(user?.message))
            },
                (error) => {
                    dispatch(failure(error));
                    dispatch(alertActions.error(error));
                }
            );
        };
        function request(customer) { return { type: customerConstants.CUSTOMER_BLOCK_REQUEST, customer }; }
        function success(customer) { return { type: customerConstants.CUSTOMER_BLOCK_SUCCESS, customer }; }
        function failure(error) { return { type: customerConstants.CUSTOMER_BLOCK_FAILURE, error }; }

    } catch (error) {
        console.log("Error at updateCustomer", error);
    }
}
const softDelete = (data) => {
    try {
        const credential = {
            method: 'POST',
            header: headerForPrivateAPI(),
            body: data || "",
            endPoint: "/customer/softDelete"
        }
        return (dispatch) => {
            dispatch(request({ data }));
            APIcallFunction(credential).then((customer) => {
                dispatch(customerList())
                dispatch(success(customer));
                dispatch(alertActions.success("Customer Deleted Successfully"));
                // dispatch(alertActions.success(user?.message))
            },
                (error) => {
                    dispatch(failure(error));
                    dispatch(alertActions.error(error));
                }
            );
        };
        function request(customer) { return { type: customerConstants.CUSTOMER_SOFT_DELETE_REQUEST, customer }; }
        function success(customer) { return { type: customerConstants.CUSTOMER_SOFT_DELETE_SUCCESS, customer }; }
        function failure(error) { return { type: customerConstants.CUSTOMER_SOFT_DELETE_FAILURE, error }; }

    } catch (error) {
        console.log("Error at softDelete", error);
    }
}



const getGraphData = (data) => {
    try {
        const credential = {
            method: 'POST',
            header: headerForPrivateAPI(),
            body: data || "",
            endPoint: "/customer/getGraphData"
        }
        return (dispatch) => {
            dispatch(request({ data }));
            APIcallFunction(credential).then((customer) => {
                dispatch(success(customer));

            },
                (error) => {
                    dispatch(failure(error));
                    dispatch(alertActions.error(error));
                }
            );
        };
        function request(customer) { return { type: customerConstants.GET_GRAPH_LIST_REQUEST, customer }; }
        function success(customer) { return { type: customerConstants.GET_GRAPH_LIST_SUCCESS, customer }; }
        function failure(error) { return { type: customerConstants.GET_GRAPH_LIST_FAILURE, error }; }

    } catch (error) {
        console.log("Error at customerList", error);
    }
}



const adminCustomer = (data) => {
    try {
        const credential = {
            method: 'POST',
            header: headerForPrivateAPI(),
            body: data || "",
            endPoint: "/customer/assinedCustomer"
        }
        return (dispatch) => {
            dispatch(request({ data }));
            APIcallFunction(credential).then((customer) => {
                dispatch(success(customer));
            },
                (error) => {
                    dispatch(failure(error));
                    dispatch(alertActions.error(error));
                }
            );
        };
        function request(customer) { return { type: customerConstants.ASSIGN_CUSTOMER_GET_LIST_REQUEST, customer }; }
        function success(customer) { return { type: customerConstants.ASSIGN_CUSTOMER_GET_LIST_SUCCESS, customer }; }
        function failure(error) { return { type: customerConstants.ASSIGN_CUSTOMER_GET_LIST_FAILURE, error }; }

    } catch (error) {
        console.log("Error at customerList", error);
    }
}


const getAllCustomer = (data) => {
    console.log("11111111111", "getAllCustomer");
    try {
        const credential = {
            method: 'POST',
            header: headerForPrivateAPI(),
            body: data || "",
            endPoint: "/customer/allCustomer"
        }
        return (dispatch) => {
            dispatch(request({ data }));
            APIcallFunction(credential).then((customer) => {
                dispatch(success(customer));
            },
                (error) => {
                    dispatch(failure(error));
                    dispatch(alertActions.error(error));
                }
            );
        };
        function request(customer) { return { type: customerConstants.GET_ALL_CUSTOMER_REQUEST, customer }; }
        function success(customer) { return { type: customerConstants.GET_ALL_CUSTOMER_SUCCESS, customer }; }
        function failure(error) { return { type: customerConstants.GET_ALL_CUSTOMER_FAILURE, error }; }

    } catch (error) {
        console.log("Error at getAllCustomer", error);
    }
}



export const customerActions = {
    customerList,
    getAlalyticsCount,
    saveCustomer,
    updateCustomer,
    blockUnblock,
    softDelete,
    getGraphData,
    adminCustomer,
    getAllCustomer
}